'use client';
import { FaTwitter, FaGithub } from 'react-icons/fa'
import Link from 'next/link'
import { usePathname } from 'next/navigation';

const menu = [
  { href: '/', value: 'Home' },
  { href: '/blog', value: 'Writing' },
  { href: '/cv', value: 'CV' },
  { href: '/contact', value: 'Hire me' },
]
const social = [
  {
    href: 'https://twitter.com/nervetattoo',
    children: <FaTwitter size={24} />,
      'aria-label': 'nervetattoo on Twitter',
    key: 'twitter',
  },
  {
    href: 'https://github.com/nervetattoo',
    children: <FaGithub size={24} />,
      'aria-label': 'nervetattoo on Github',
    key: 'github',
  },
]
export function Header () {
  const pathname = usePathname();

  return (
    <header className={`
      py-2 mb-2
      border-b
      border-bayoux-900
    `}>
      <nav
        className={`
          mx-auto
          max-w-screen-xl
          px-4 xl:px-0
          py-2
          text-xl
          flex
          justify-between
          items-center
          gap-4
        `}
      >
          { menu.map(item => {
            const active = item.href === "/"
              ? pathname === "/"
              : pathname.startsWith(item.href)
            return (
              <Link
                key={item.value}
                href={item.href}
                className={`
                  ${active
                    ? 'text-amber-500 underline'
                    : 'text-white no-underline'
                  }
                  hover:text-amber-400
                  underline-offset-8
                `}
              >
                {item.value}
              </Link>
            )
          })}
          <span className='ml-auto' />
        <div className='hidden md:flex gap-4'>
          { social.map(props => {
            return (
              <Link
                key={props.key}
                className={`
                  text-white
                  hover:text-amber-400
                `}
                {...props}
              />
            )
          }) }
        </div>
      </nav>
    </header>
  )
}

